import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';

const Testimonials = () => {
  const [data, setData] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
       const res = await api.get('/Testimonials');
        setData(res.data);
      } catch (err) {
        console.error("Error fetching testimonials", err);
      }
    };
    fetchData();
  }, []);

  if (!data || !data.cta) return <div className="text-center py-5">Loading Reviews...</div>;

  const { reviews, stats, cta } = data;

  return (
    <section className="testimonials-section py-5 bg-light" id="testimonials">
      <div className="container">
        
        {/* Section Header */}
        <div className="text-center mb-5">
          <span className="badge bg-success mb-3 px-3 py-2">
            <i className="bi bi-chat-quote-fill me-2"></i>
            Customer Testimonials
          </span>
          <h2 className="display-5 fw-bold text-dark mb-3">What Our Customers Say</h2>
          <p className="lead text-muted">Real stories from satisfied solar users across Bihar & Jharkhand</p>
        </div>

        {/* Testimonials Grid (Dynamic) */}
        <div className="row g-4">
          {reviews.map((testimonial, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="testimonial-card card border-0 shadow-sm h-100">
                <div className="card-body p-4 d-flex flex-column">
                  
                  {/* Quote Icon */}
                  <div className="quote-icon mb-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.2 }}>
                    <FaQuoteLeft style={{ fontSize: '1.5rem', color: '#ffffff' }} />
                  </div>

                  {/* Rating */}
                  <div className="rating mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} style={{ color: '#FFD700', fontSize: '1.2rem', marginRight: '3px' }} />
                    ))}
                  </div>

                  {/* Text */}
                  <p className="testimonial-text flex-grow-1 mb-4" style={{ fontSize: '0.95rem', lineHeight: '1.7', color: '#555', fontStyle: 'italic' }}>
                    "{testimonial.text}"
                  </p>

                  {/* Stats */}
                  <div className="testimonial-stats mb-3 d-flex gap-3">
                    <div className="stat-badge px-3 py-2 rounded" style={{ background: '#E8F8F3', fontSize: '0.85rem' }}>
                      <i className="bi bi-lightning-charge-fill text-success me-1"></i>
                      <strong>{testimonial.systemSize}</strong> System
                    </div>
                    <div className="stat-badge px-3 py-2 rounded" style={{ background: '#E8F8F3', fontSize: '0.85rem' }}>
                      <i className="bi bi-graph-down text-success me-1"></i>
                      <strong>{testimonial.savingsPercent}</strong> Savings
                    </div>
                  </div>

                  {/* Author */}
                  <div className="testimonial-author border-top pt-3">
                    <div className="d-flex align-items-center">
                      <div className="author-avatar me-3" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, #1B3F6E 0%, #2E5C8A 100%)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', fontSize: '1.2rem', fontWeight: 'bold' }}>
                        {testimonial.name.charAt(0)}
                      </div>
                      <div>
                        <h5 className="mb-0 fw-bold" style={{ color: '#1B3F6E', fontSize: '1rem' }}>{testimonial.name}</h5>
                        <p className="mb-0 text-muted small">
                          <i className="bi bi-geo-alt-fill me-1" style={{ color: '#00D084' }}></i>
                          {testimonial.location}
                        </p>
                        <p className="mb-0 text-muted" style={{ fontSize: '0.8rem' }}>{testimonial.profession}</p>
                      </div>
                    </div>
                  </div>

                  {/* Verified Badge */}
                  <div className="verified-badge mt-3">
                    <span className="badge text-success px-3 py-2" style={{ background: '#E8F8F3', fontSize: '0.75rem' }}>
                      <i className="bi bi-patch-check-fill me-1"></i> Verified RENGIE Customer
                    </span>
                  </div>

                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA (Dynamic) */}
        <div className="row mt-5">
          <div className="col-lg-8 mx-auto">
            <div className="card border-0 shadow-lg text-center p-4" style={{ background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)' }}>
              <div className="card-body">
                <h4 className="text-white fw-bold mb-3"><i className="bi bi-star-fill me-2"></i>{cta.title}</h4>
                <p className="text-white mb-4 opacity-90">{cta.description}</p>
                <a href="#contact" className="btn btn-light btn-lg rounded-pill px-5 fw-bold" style={{ color: '#1B3F6E' }}>
                  <i className="bi bi-telephone-fill me-2"></i> {cta.buttonText}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Stats (Dynamic) */}
        <div className="row mt-4">
          {stats.map((stat, index) => (
            <div className="col-md-4 text-center mb-3 mb-md-0" key={index}>
              <h3 className="fw-bold mb-1" style={{ color: '#00D084' }}>{stat.value}</h3>
              <p className="text-muted small mb-0">{stat.label}</p>
            </div>
          ))}
        </div>

      </div>

      <style jsx>{`
        .testimonial-card { transition: all 0.3s ease; position: relative; overflow: hidden; }
        .testimonial-card::before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 4px; background: linear-gradient(90deg, #00D084, #00A86B); transform: scaleX(0); transition: transform 0.3s ease; }
        .testimonial-card:hover::before { transform: scaleX(1); }
        .testimonial-card:hover { transform: translateY(-10px); box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15) !important; }
        .quote-icon { position: absolute; top: 20px; right: 20px; }
      `}</style>
    </section>
  );
};

export default Testimonials;